import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import {css} from "@emotion/core";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { List } from 'react-virtualized';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from "react-awesome-modal";
import {connect}  from  "react-redux";
import loadingGif from "../../assets/img/loading.gif";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, aplloClient,user_activities } from '../../helpers/utils.js';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import DownloadAllReport from '../DownloadReport/DownloadAllReport.jsx';
import MerchantFilter from '../../filters/MerchantFilter.jsx';
import ChainFilter from '../../filters/ChainFilter.jsx';
import StoreFilter from '../../filters/StoreFilter.jsx';
import UtidFilter from '../../filters/UtidFilter.jsx';
import AcquirerFilter from '../../filters/AcquirerFilter.jsx';
import SubventionFilter from '../../filters/SubventionFilter.jsx';
import CategoryFilter from '../../filters/CategoryFilter.jsx';
import BrandFilter from '../../filters/BrandFilter.jsx';
import ModelFilter from '../../filters/ModelFilter.jsx';
import EMISchemeFilter from '../../filters/EMISchemeFilter.jsx';
import TenureFilter from '../../filters/TenureFilter.jsx';
import EMIIssuerFilter from '../../filters/EMIIssuerFilter.jsx';
import TxnTypeFilter from '../../filters/TxnTypeFilter1.jsx';
import SettledUnsettledFilter from '../../filters/settled_unsettledFilter.jsx';
import ProductTypeFilter from '../../filters/ProductTypeFilter.jsx';
import ServiceFilter from '../../filters/ServiceFilter.jsx';
import IndustryCategoryFilter from '../../filters/IndustryCategoryFilter.jsx';
import PosbillFilter from '../../filters/PosbillFilter.jsx';
import PrimIdFilter from '../../filters/PrimIdFilter.jsx';

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;

var date_config = date_range_config('0', '0', '2020-02-01','0');
var FlexiPayTraTable='';

class FlexiPayTransactionReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            merchantID:'',
            chainID:'',
            storeID:'',
            acqBankIds:'',
            issuerBankIds:'',
            cityIds:'',
            loading:false,
            is_void:1,
            model_visible : false,
            file_url: '',
            rfile: '',
            subventionIDs:'',
            categoryIDs:'',
            brandIDs:'',
            modelIDs:'',
            emiSchemeIDs:'',
            tenureIDs:'',
            emiIssuerValue:'',
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            issuer_bank_list_box: true,
            is_store_loading: true,
            is_chain_loading: true,
            is_merchant_loading: true,
            txnTypeIDs: ['SALE'],
            ciutidIds: '',
            is_utid_loading: true,
            isSettledLists: [],
            isSettledIDs: '',
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            listOpen: false,
            headerTitle: "Select [Utid]",
            productTypeIDs: '',
            serviceTypeIDs: '',
            object_code:[],
            storeObject:[],
            search_object_code:[],
            fetch_data:false,
            isProductLoading: true
        }
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        isReportAccess(AllAccessPermissions, 'flexi_pay_transaction');
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });
    }

    componentDidUpdate() {

    }
    componentDidMount() {
        this.get_filtered_flexiPay_transaction_report(this.state.object_type,this.state.object_code,'');
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'flexi_pay_transaction','sparcs')
    }

     transactionReportDownloadCheck (e){
        let transaction_type = this.state.txnTypeIDs;
        if (Array.isArray(this.state.txnTypeIDs) && this.state.txnTypeIDs.includes("all") === true) {
            transaction_type = ""
        }
        let filters = {
            merchant_codes: this.state.merchantID,
            chain_codes: this.state.chainID,
            store_codes: this.state.storeID,
            acq_bank_codes: this.state.acqBankIds,
            city: this.state.cityIds,
            start_date: this.state.yestSend,
            end_date: this.state.todSend,
            metric: this.state.metric,
            show_void_transactions: this.state.is_void,
            download: 1,
            txn_type: 'EMI',
            subventionIDs: this.state.subventionIDs,
            categoryIDs: this.state.categoryIDs,
            brandIDs: this.state.brandIDs,
            modelIDs: this.state.modelIDs,
            emiSchemeIDs: this.state.emiSchemeIDs,
            tenureIDs: this.state.tenureIDs,
            emiIssuerIDs: this.state.emiIssuerIDs,
            transaction_type: transaction_type,
            utid: this.state.ciutidIds,
            is_settled: this.state.isSettledIDs,
            show_pos_bill_input_columns: this.state.is_posbillinput,
            show_txn_prim_id: this.state.is_prim_id,
            product_type: this.state.productTypeIDs,
            service_type: this.state.serviceTypeIDs,
//             category_code: this.state.industryCategoryIds,
            gst_columns: 0,
        }
        this.setState({
            filters:filters
        })
        let is_txn = false;
        if(this.state.txnTypeIDs.length===1 && this.state.txnTypeIDs[0]==='SALE')
        {
           is_txn = true;
        }
        if(this.state.merchantID==='' && this.state.chainID==='' && this.state.storeID==='' && this.state.ciutidIds==='' && this.state.acqBankIds===''
        && this.state.cityIds==='' && this.state.tenderModeIDs==='' && this.state.txnissuerIDs==='' && this.state.schemeIDs===''
        && this.state.cardTypeIDs==='' && this.state.isSettledIDs==='' && this.state.productTypeIDs==='' && this.state.serviceTypeIDs==='' && is_txn ===true
        && this.state.communicationIdIds===''){
            confirmAlert({
            //title: 'Warning',
                message: "Do you really want to download all data for date range: "+this.state.datefromShow+" - "+this.state.dateToShow+" ? This will take some time to download depending on volume of data. Alternatively, please apply a filter.",
                buttons: [{
                    label: 'OK',
                    onClick: () => {
                        this.refs.downloadAllReport.downLoadReport(filters, '/report/transaction/daily/flexipay','flexi_pay_transaction_report');
                    }
                },
                    {
                        label: 'Cancel',
                    }
                ]
            });
        } else {
            this.refs.downloadAllReport.downLoadReport(filters, '/report/transaction/daily/flexipay','flexi_pay_transaction_report');
        }
    }
    get_filtered_flexiPay_transaction_report(object_type, object_code, event) {
        var that = this;
        var corCol = 'Merchant';
        var ufeCol = 'Merchant';
        if(that.state.txnTypeIDs.includes("FAILED")===true  || that.state.txnTypeIDs.includes("all")===true) {
            corCol = 'Co Reason Message';
            ufeCol = 'Ufe Message';
        }
        var pos_order_id = 'Merchant';
        var grab_order_id = 'Merchant';
        var grab_client_id = 'Merchant';
        var pos_merchant = 'Merchant';
        if(that.state.is_posbillinput==1){
            grab_order_id = 'Grab Order ID';
            pos_order_id = 'Pos Order ID';
            grab_client_id = 'Grab Client ID';
            pos_merchant = 'Pos Merchant ID';
        }
        isApiResponse(false)
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        var acqBank = this.state.acqBankIds;
        var emiIssuer = this.state.emiIssuerIDs;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }
        if(object_type==='Acquiring Bank' && this.state.storeID===''){
            acqBank = object_code;
        }
        if(object_type==='Issuing Bank' && this.state.storeID===''){
            emiIssuer = object_code;
        }
        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            bids: acqBank,
            cityids: this.state.cityIds,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            metric: this.state.metric,
            is_void: this.state.is_void,
            txn_type: 'EMI',
            subventionIDs: this.state.subventionIDs,
            categoryIDs: this.state.categoryIDs,
            brandIDs: this.state.brandIDs,
            modelIDs: this.state.modelIDs,
            emiSchemeIDs: this.state.emiSchemeIDs,
            tenureIDs: this.state.tenureIDs,
            emiIssuerIDs: emiIssuer,
            transaction_type: this.state.txnTypeIDs,
            utid: this.state.ciutidIds,
            is_settled: this.state.isSettledIDs,
            is_posbillinput: this.state.is_posbillinput,
            show_txn_prim_id: this.state.is_prim_id,
            product_type: this.state.productTypeIDs,
            service_type: this.state.serviceTypeIDs

        };
        if ($.fn.DataTable.isDataTable('#FlexiPayTraTable')) {
            $('#FlexiPayTraTable').DataTable().clear().destroy();
        }
        var FlexiPayTraTable = $('#FlexiPayTraTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                //"autoWidth": false,
                "responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/reports/flexi-pay-txn-reports",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        isApiResponse(true)
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                        console.log("error", data);
                    },
                    complete: function (data) {
                        isApiResponse(true)
                    },
                },

                columns: [
                    {"data":"Merchant", "width":"150px"},
                    {"data":"Chain", "width":"100px"},
                    {"data":"Store Name", "width":"100px"},
                    {"data":"Store Address 1", "width":"100px"},
                    {"data":"Store Address 2", "width":"100px"},
                    {"data":"City"},
                    {"data": "echargeslip_url"},
                    {"data":"Product Amount"},
                    {"data":"Sale Amount"},
                    {"data":"Transaction Amount"},
                    {"data":"Loan Amount"},
                    {"data":"EMI Amount"},
                    {"data":"Instant Discount"},
                    {"data":"No Cost EMI Amount"},
                    {"data":"Additional Cashback"},
                    {"data":"Interest Amount"},
                    {"data":"Rate of Interest"},
                    {"data":"Transaction Date"},
                    {"data":"Transaction Time"},
                    {"data":"Btid"},
                    {"data":"Utid"},
                    {"data": "Card Number"},
                    {"data": "Acquirer Bank"},
                    {"data":"Issuer Bank"},
                    {"data":"Scheme"},
                    {"data":"Card Grade"},
                    {"data":"Card Type"},
                    {"data":"Base Amount"},
                    {"data":"RRN No"},
                    {"data":"Approval Code"},
                    {"data":"Merchant Id"},
                    {"data":"Merchant Invoice Number"},
                    {"data":"Batchsrl"},
                    {"data":"Invoice"},
                    {"data": "Bank Merchant Id"},
                    {"data":"Processing Code"},
                    {"data":"Transaction Type"},
                    {"data":"Card Holder Name"},
                    {"data":"Acquirer Approval Code"},
                    {"data":"Acquirer RRN Number"},
                    {"data":"Acquirer Amount"},
                    {"data":"Bank Reference No"},
                    {"data":"Order Confirmation No"},
                    {"data":"Tenure"},
                    {"data":"Subvention"},
                    {"data":"Brand"},
                    {"data":"Issuer"},
                    {"data":"Category"},
                    {"data":"Scheme Name"},
                    {"data":"Model"},
                    {"data":"Merchant SKU"},
                    {"data":"Cashback Amount"},
                    {"data":"Innoviti Subvention"},
                    {"data":"Merchant Subvention"},
                    {"data":"Brand Subvention"},
                    {"data":"Bank Subvention"},
                    {"data":"Settlement Date"},
                    {"data":"Settled/Unsettled"},
                    {"data":corCol},
                    {"data":ufeCol},
                    {"data":grab_order_id },
                    {"data":pos_order_id },
                    {"data":grab_client_id },
                    {"data":pos_merchant },
                    {"data":"prim_id" },
                    {"data":"parent_prim_id"},
                    {"data":"Bin No" },
                    {"data":"EMI Bank Code"},
                    {"data":"State"},
                    {"data": "Logo"},
                    {"data": "service type"}
                ],
                "columnDefs": [
//                     {  render: function (data) {
//                             return '<td >'+moment(data).format('D MMM YYYY')+'</td>';
//                         },
//                         "width": "80px",
//                         "targets": 20
//                     },
                    {
                        render: function (data, type, row) {
                            if(row['Settled/Unsettled']==="Failed" || row['Settled/Unsettled']==="FAILED") {
                                return '<td ></td>';
                            }
                            else{
                                return '<td ><a href="#" data-code ="' + data + '" data-trdate ="' + row['Transaction Date'] + '" data-acqbank ="' + row['Acquirer Bank'] + '" data-primid ="' + row['prim_id'] + '">Get Receipt</a> &nbsp;</td>';
                            }
                        },
                        className: "charge_slip",
                        targets: 6,
                        aTargets: [-1]
                    },
                    {
                        render: function (data, type, full, meta) {
                            if(data===null || data===''|| data ==='null'){
                            data = '';
                            }
                            return "<div class='text-wrap width-150'>" + data + "</div>";
                        },
                        "targets": [0,1,2]
                    },
                ],
            });
         if(that.state.txnTypeIDs.includes("FAILED")===true  || that.state.txnTypeIDs.includes("all")===true) {
// //             FlexiPayTraTable.columns(7).visible(false);
            FlexiPayTraTable.columns(58).visible(true);
            FlexiPayTraTable.columns(59).visible(true);
         } else {
// //             FlexiPayTraTable.columns(7).visible(true);
            FlexiPayTraTable.columns(58).visible(false);
            FlexiPayTraTable.columns(59).visible(false);
         }
        if(that.state.is_posbillinput===1) {
            FlexiPayTraTable.columns(60).visible(true);
            FlexiPayTraTable.columns(61).visible(true);
            FlexiPayTraTable.columns(62).visible(true);
            FlexiPayTraTable.columns(63).visible(true);
        } else {
            FlexiPayTraTable.columns(60).visible(false);
            FlexiPayTraTable.columns(61).visible(false);
            FlexiPayTraTable.columns(62).visible(false);
            FlexiPayTraTable.columns(63).visible(false);
        }
        if(that.state.is_prim_id===1) {
            FlexiPayTraTable.columns(64).visible(true);
            if(that.state.txnTypeIDs.includes("REVERSAL")===true || that.state.txnTypeIDs.includes("VOID")===true || that.state.txnTypeIDs.includes("FAILED")===true|| that.state.txnTypeIDs.includes("all")===true) {
                FlexiPayTraTable.columns(65).visible(true);
            } else {
                FlexiPayTraTable.columns(65).visible(false);
           }
        } else {
            FlexiPayTraTable.columns(64).visible(false);
            FlexiPayTraTable.columns(65).visible(false);
        }

        $('#FlexiPayTraTable').on('click', 'td.charge_slip a', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var code = $(this).data("code");
            var acqbank = $(this).data("acqbank");
            var trdate = $(this).data("trdate");
            var prim_id = $(this).data("primid");
            let win=window.open('about:blank','popUpWindow', 'height=500,width=400,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes' )
            var perLoad = '<div style="text-align: center" id="loaderDiv"><img src=" '+ loadingGif +' "></div>';
            win.document.write(perLoad)
            $.ajax({
                url:config.get('API_URL')+ "/reports/generate_slip/?code="+code+"&acq_bank_name="+acqbank+"&transaction_date="+trdate+"&prim_id="+prim_id,
                type: 'GET',

                beforeSend: function (request) {
                    request.setRequestHeader("Authorization", localStorage.usertoken);
                },
                success: function (response) {
                    win.document.close();
                    win.document.write(response)
                },
                //dataType: 'html'
            })
        })

    }
    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
        if(this.state.object_type==='Innoviti')
        {
            this.refs.merchantFilter.restMerchantFilter();
            this.refs.reloadChain.getChain(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code, false,'');
            this.refs.reloadUtid.ci_utid('','','',false,'');
        }
        if(this.state.object_type==='Merchant')
        {
            this.refs.reloadChain.getChain(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code,false,'');
            this.refs.reloadUtid.ci_utid(this.state.object_code,'','',false,'');
        }
        if(this.state.object_type==='Chain')
        {
            this.refs.reloadStore.getStore(this.state.object_code, 'chain', this.state.object_type, this.state.object_code,false,'');
            this.refs.reloadUtid.ci_utid('',this.state.object_code,'',false,'');
        }
        if(this.state.object_type==='Store')
        {
            this.refs.reloadUtid.ci_utid('','',this.state.object_code,false,'');
        }
        if(this.state.object_type=='Innoviti' || this.state.object_code.includes("RELI0001")===true)
        {
            this.refs.serviceFilter.restServiceFilter();
            this.refs.productTypeFilter.resetProductTypeFilter();

        }
         this.refs.acquirerFilter.resetAcquirerFilter();
         this.refs.serviceFilter.restServiceFilter();
         this.refs.subventionFilter.resetSubventionFilter();
         this.refs.txnTypeFilter.resetTxnTypeFilter();
         this.refs.settledFilter.resetSettledFilter();
         this.refs.categoryFilter._getCategory(date_config.start_date_value, date_config.end_date_value);
         this.refs.eMISchemeFilter.resetEMISchemeFilter();
         this.refs.tenureFilter.resetTenureFilter();
         this.refs.eMIIssuerFilter.resetEMIIssuerFilter();
         this.refs.brandFilter._getBrand(date_config.start_date_value, date_config.end_date_value);
         this.refs.modelFilter._getModel(date_config.start_date_value, date_config.end_date_value);
         this.refs.posbillFilter.resetPosbillFilter();
         this.refs.primIdFilter.resetPrimIdFilter();
        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:[],
            chainValue:[],
            acqBankValue: [],
            acqBankIds:'',
            issuerBankValue:[],
            issuerBankIds:'',
            cityValue:[],
            cityIds:'',
            is_void:1,
            file_url: '',
            rfile: '',
            subventionValue:[],
            subventionIDs:'',
            categoryValue:[],
            categoryIDs:'',
            brandValue:[],
            brandIDs:'',
            modelValue:[],
            modelIDs:'',
            emiSchemeValue:[],
            emiSchemeIDs:'',
            tenureValue:[],
            tenureIDs:'',
            emiIssuerValue:[],
            emiIssuerIDs:'',
            storeValue:[],
            txnTypeIDs: ['SALE'],
            txnTypeValue: [{value: "SALE", label: "SALE"}],

            ciutidValue: [],
            ciutidIds: '',

            isSettledIDs: '',
            isSettledValue: [],
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            serviceTypeIDs: '',
            serviceTypeValue: {value: '', label: 'All'},
            productTypeIDs: '',
            productTypeValue: {value: '', label: 'All'},
        })

        setTimeout(function(){
            this.componentWillMount()
            this.componentDidMount()
        }.bind(this), 200);
    }
    handleMerchant = (optionSelected, merchantID) =>
    {
        this.setState({
            merchantID:merchantID,
            isChange: true,
            chainID:'',
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadChain.getChain(merchantID, 'merchant', this.state.object_type, this.state.object_code);
        this.refs.reloadStore.getStore(merchantID, 'merchant', this.state.object_type, this.state.object_code,false,'');
        this.refs.reloadUtid.ci_utid(merchantID, '','',false,'');
    }
    handleChain = (optionSelected, chainID) =>
    {
        this.setState({
            chainID:chainID,
            isChange: true,
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadStore.getStore(chainID, 'chain', this.state.object_type, this.state.merchantID,false,'');
        this.refs.reloadUtid.ci_utid(this.state.merchantID, chainID,'',false,'');
    }

    handleStore = (storeID) =>
    {
        this.setState({
            storeID:storeID,
            isChange: true,
            ciutidIds: '',

        });
        this.refs.reloadUtid.ci_utid(this.state.merchantID, this.state.chainID,storeID,false,'');
    }
    handleUtid = (utid) =>
    {
        this.setState({
            ciutidIds:utid,
            isChange: true
        });

    }

    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
        this.refs.categoryFilter._getCategory(yestSend, todSend);
        this.refs.brandFilter._getBrand(yestSend, todSend);
        this.refs.modelFilter._getModel(this.state.brandIDs,yestSend, todSend);
        this.refs.tenureFilter._getTenure(yestSend, todSend);
        this.refs.eMISchemeFilter._getEmiScheme(yestSend, todSend);
    }
    handleService = (serviceData) =>{
        const value = serviceData === null ? '' : serviceData.value;
        this.setState({
            serviceTypeValue: serviceData,
            isChange: true,
            serviceTypeIDs:value,
        })
    }
    handleSubvention = (optionSelected,subventionIDs) =>{
        this.setState({
            subventionValue: optionSelected ,
            isChange: true,
            subventionIDs:subventionIDs,
        })
    }
    handleTxnType = (optionSelected, txnTypeIDs) =>
    {
        this.setState({
            txnTypeIDs:txnTypeIDs,
            txnTypeValue:optionSelected,
            isChange: true
        });
    }
    handleAcquirer = (optionSelected, acqBankIds) =>
    {
        this.setState({
            acqBankIds:acqBankIds,
            isChange: true
        });
    }
    handleProduct = (productData) =>{
        const value = productData === null ? '' : productData.value;
        this.setState({
            isChange: true,
            productTypeIDs:value,
        })
    }
    handleSettled = (optionSelected, isSettledIDs) =>
    {
        this.setState({
            isSettledIDs:isSettledIDs,
            isSettledValue:optionSelected,
            isChange: true
        });
    }
    handleCategory = (optionSelected, categoryIDs) =>
    {
        this.setState({
            categoryIDs:categoryIDs,
            categoryValue: optionSelected,
            isChange: true
        });
    }
    handleBrand = (optionSelected, brandIDs) =>
    {
        this.setState({
            brandIDs:brandIDs,
            brandValue:optionSelected,
            isChange: true
        });
        this.refs.modelFilter._getModel(brandIDs,this.state.yestSend,this.state.todSend);
    }
    handleModel = (optionSelected, modelIDs) =>
    {
        this.setState({
            modelIDs:modelIDs,
            modelValue:optionSelected,
            isChange: true
        });
    }
    handleEMIScheme = (optionSelected, emiSchemeIDs) =>
    {
        this.setState({
            emiSchemeIDs:emiSchemeIDs,
            emiSchemeValue:optionSelected,
            isChange: true
        });
    }
    handleTenure = (optionSelected, tenureIDs) =>
    {
        this.setState({
            tenureIDs:tenureIDs,
            tenureValue:optionSelected,
            isChange: true
        });
    }
    handleEmiIssuer = (optionSelected, emiIssuerIDs) =>
    {
        this.setState({
            emiIssuerIDs:emiIssuerIDs,
            emiIssuerValue:optionSelected,
            isChange: true
        });
    }
//     handleIndustryCategoryFilter = (optionSelected, industryCategoryIds) =>
//     {
//         this.setState({
//             industryCategoryIds:industryCategoryIds,
//             isChange: true
//         });
//     }
    handlePosBill = (is_posbillinput) => {
        this.setState({is_posbillinput: is_posbillinput, isChange: true});
    }
    handlePrimId = (is_prim_id) => {
        this.setState({is_prim_id: is_prim_id, isChange: true});
    }


    render() {
        return(

            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">FlexiPay Transaction Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-10 filter-border-right">
                                    <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                        <div><label> Date Filter: </label></div>
                                        <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                        start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/>
                                    </div>
                                    {this.state.object_type ==='Innoviti'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label>Merchants</label>
                                                    <MerchantFilter ref="merchantFilter" onSelectMerchant = {this.handleMerchant} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div> : null}
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Chain </label>
                                                    <ChainFilter ref= "reloadChain" onSelectChain = {this.handleChain} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant' || this.state.object_type ==='Chain'?
                                                <div className="col-md-2 filter-bottom5 padd-5" >
                                                    <label> Store: </label>
                                                    <StoreFilter ref= "reloadStore" onSelectStore = {this.handleStore} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            <div className="col-md-2 filter-bottom5 padd-5" >
                                                <label> Utid: </label>
                                                <UtidFilter ref = "reloadUtid" onSelectUtid = {this.handleUtid} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                <div className="clearfix"></div>
                                            </div>
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label>Acquirer:</label>
                                        <AcquirerFilter ref="acquirerFilter" onSelectAcquirer = {this.handleAcquirer}/>
                                        <div className="clearfix"></div>
                                      </div>

                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> Subvention </label>
                                        <SubventionFilter  ref="subventionFilter" onSelectSubvention = {this.handleSubvention} />
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> Category </label>
                                        <CategoryFilter  ref="categoryFilter" onSelectCategory = {this.handleCategory} start_date = {this.state.yestSend} end_date={this.state.todSend} />
                                        <div className="clearfix"></div>
                                    </div>


                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label>Brand:</label>
                                        <BrandFilter ref="brandFilter" onSelectBrand = {this.handleBrand} start_date = {this.state.yestSend} end_date={this.state.todSend} />
                                        <div className="clearfix"></div>

                                    </div>
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> Model: </label>
                                        <ModelFilter ref="modelFilter" onSelectmodel = {this.handleModel} start_date = {this.state.yestSend} end_date={this.state.todSend} />
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> EMI Scheme: </label>
                                        <EMISchemeFilter ref="eMISchemeFilter" onSelectEMIScheme = {this.handleEMIScheme} start_date = {this.state.yestSend} end_date={this.state.todSend} />
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> Tenure: </label>
                                        <TenureFilter ref="tenureFilter" onSelectTenure = {this.handleTenure} start_date = {this.state.yestSend} end_date={this.state.todSend} />
                                        <div className="clearfix"></div>
                                    </div>
                                    {this.state.issuer_bank_list_box==true?
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> EMI Issuer: </label>
                                         <EMIIssuerFilter ref="eMIIssuerFilter" onSelectEMIIssuer = {this.handleEmiIssuer} />
                                        <div className="clearfix"></div>
                                    </div>: null}

                                    <div className="col-md-2 filter-bottom5 padd-5">
                                         <label> Txn Type </label>
                                                <TxnTypeFilter ref="txnTypeFilter" onSelectTxnType = {this.handleTxnType} is_upi_leg1 = 'No' />
                                                <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> Settled/Unsettled </label>
                                        <SettledUnsettledFilter ref="settledFilter" onSelectSettled = {this.handleSettled}/>
                                        <div className="clearfix"></div>
                                    </div>
                                            {this.state.object_type=='Innoviti' || this.state.object_code.includes("RELI0001")===true?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Product Type </label>
                                                     <ProductTypeFilter ref="productTypeFilter" onSelectProduct = {this.handleProduct} userType={this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }

                                            {this.state.object_type=='Innoviti' || this.state.object_code.includes("RELI0001")===true?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Service Type </label>
                                                    <ServiceFilter ref="serviceFilter" onSelectService = {this.handleService} userType={this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }

                                         </div>
                                        <div className="col-md-2 filter-bottom5 ">
                                            <div className="top-margin-30">
                                              <PosbillFilter ref="posbillFilter" onSelectPosbill = {this.handlePosBill} />
                                             </div>

                                            <div>
                                                <PrimIdFilter ref="primIdFilter" onSelectPrimId = {this.handlePrimId} />
                                            </div>

                                         </div>
                                     </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }

                                        <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_flexiPay_transaction_report.bind(this, this.state.object_type,this.state.object_code)}>Apply</button>&nbsp; &nbsp;
                                            <button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>

                                    </div>
                                    </div>

                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.transactionReportDownloadCheck.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="FlexiPayTraTable" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th width="150px">Merchant</th>
                                                <th width="100px">Chain</th>
                                                <th width="100px">Store Name</th>
                                                <th width="100px">Store Address 1</th>
                                                <th width="100px">Store Address 2</th>
                                                <th>City</th>
                                                <th>Digital Chargeslip</th>

                                                <th>Product Amount</th>
                                                <th>Sale Amount</th>
                                                <th>Transaction Amount</th>
                                                <th>Loan Amount</th>
                                                <th>EMI Amount</th>
                                                <th>Instant Discount</th>
                                                <th>No Cost EMI Amount</th>
                                                <th>Additional Cashback</th>
                                                <th>Interest Amount</th>
                                                <th>Rate of Interest</th>
                                                <th>Transaction Date</th>
                                                <th>Transaction Time</th>
                                                <th>Btid</th>
                                                <th>Utid</th>
                                                <th>Card Number</th>
                                                <th>Acquirer Bank</th>
                                                <th>Issuer Bank</th>
                                                <th>Scheme</th>
                                                <th>Card Grade</th>
                                                <th>Card Type</th>
                                                <th>Base Amount</th>
                                                <th>RRN No</th>
                                                <th>Approval Code</th>
                                                <th>Merchant Id</th>
                                                <th>Merchant Invoice Number</th>
                                                <th>Batchsrl</th>
                                                <th>Invoice</th>
                                                <th>Bank Merchant Id</th>
                                                <th>Processing Code</th>
                                                <th>Transaction Type</th>
                                                <th>Card Holder Name</th>
                                                <th>Acquirer Approval Code</th>
                                                <th>Acquirer RRN Number</th>
                                                <th>Acquirer Amount</th>
                                                <th>Bank Reference No</th>
                                                <th>Order Confirmation No</th>
                                                <th>Tenure</th>
                                                <th>Subvention</th>
                                                <th>Brand</th>
                                                <th>Issuer</th>
                                                <th>Category</th>
                                                <th>Scheme Name</th>
                                                <th>Model</th>
                                                <th>Merchant SKU</th>
                                                <th>Cashback Amount</th>
                                                <th>Innoviti Subvention</th>
                                                <th>Merchant Subvention</th>
                                                <th>Brand Subvention</th>
                                                <th>Bank Subvention</th>
                                                <th>Settlement Date</th>
                                                <th>Settled/Unsettled</th>
                                                <th>Co Reason Message</th>
                                                <th width="150">Ufe Message</th>
                                                <th>Grab Order ID</th>
                                                <th>Pos Order ID</th>
                                                <th>Grab Client ID</th>
                                                <th>Pos Merchant ID</th>
                                                <th>Prim ID</th>
                                                <th>Parent Prim ID</th>
                                                <th>Bin No</th>
                                                <th>EMI Bank Code</th>
                                                <th>State</th>
                                                <th>Logo</th>
                                                <th>Service Type</th>
                                            </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <DownloadAllReport ref="downloadAllReport" />
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      
        );
    }

}
const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)(FlexiPayTransactionReport);